export interface SystemInfo {
  name: string;
  environment: "local" | "test" | "staging" | "production";
  version: string;
  baseline_id: string;
}

export async function fetchSystemInfo(signal?: AbortSignal): Promise<SystemInfo> {
  const response = await fetch("/api/v1/system/info", {
    headers: { Accept: "application/json" },
    signal,
  });

  if (!response.ok) {
    throw new Error(`API 响应异常：${response.status}`);
  }

  return (await response.json()) as SystemInfo;
}
